import React from 'react'
import { Modal } from 'react-bootstrap'
import styled from 'styled-components'

const StyledModal = styled(Modal)`
  .modal-content {
    /* display: flex;
    justify-content: center;
    align-items: center; */
    min-height: 400px;
    width: 100%;
    background: #000;
    border: none;
    color: #fff;
    h1 {
      font-size: 18px;
      font-weight: 600;

      @media (min-width: 1280px) {
        font-size: 24px;
      }
    }
  }
  .modal-header {
    padding: 8px;
    border: none;
    background: rgba(0, 0, 0, 0);
   
    button.close {
      opacity: 1;
      padding: 4px auto !important;
      z-index: 100;
      position: absolute;
      top: -3%;
      right: -3%;
      span {
        font-weight: 400;
        font-size: 48px;
        color: #f8c605;
        text-shadow: none;
      }
    }
  }

  iframe {
    width: 100%;
    min-height: 400px;
  }
  @media (min-width: 992px) {
    .modal-lg, .modal-xl {
      max-width: 630px;
    }
  }

`

export default function GuideModal({ showModal, hideModal }) {
  return (
    <StyledModal
      show={showModal}
      onHide={hideModal}
      size="lg"
      centered
    >
      <Modal.Header closeButton />

      <Modal.Body>
        <div className="modal-content" >
          <h2 className="fw-bold text-center">USER GUIDE</h2>
        <iframe width="100%" height="100%" src="https://iframe.dacast.com/vod/1b1f6ca6-faef-317f-74bf-a4ce68f8e2d6/b906704a-2390-42e5-a0b3-884a32f2a0da" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write"  title="NTC 2025 User Guide"></iframe>
        </div>
      </Modal.Body>
    </StyledModal>
  )
}